// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.calendar-container.hide-hours .fc-axis {\n\tdisplay: none;\n}\n.calendar-container .fc-timeGrid-view .fc-day-grid{\n\tz-index:0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
